import Breadcrumb from 'react-bootstrap/Breadcrumb';

export default function fiscalBreadcrump() {
  return (
    <Breadcrumb>
      <Breadcrumb.Item href="/fiscal">home</Breadcrumb.Item>
      <Breadcrumb.Item href="/expenditure">expenditure</Breadcrumb.Item>
      <Breadcrumb.Item href= "/museum">museum</Breadcrumb.Item>
    </Breadcrumb>
  );
}

